import React, {Suspense} from 'react'
import {BrowserRouter} from 'react-router-dom'
import {Provider} from 'react-redux'
import {IntlProvider} from 'react-intl'
import {ThemeProvider, createTheme} from '@mui/material/styles'
import {CssBaseline} from '@mui/material'
import AuthInit from './modules/auth/redux/AuthInit'
import { LayoutSplashScreen } from './__core/layout/SplashScreen'
import { Routes } from './app/routing/Routes'
import store from './setup/redux/Store'
import { messages } from './locales/vi'
import ErrorBoundary from './__core/components/ErrorBoundary'
import './globalStyles.css'

// Tạo Material-UI theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
})

type Props = {
  basename: string
}

const App: React.FC<Props> = ({basename}) => {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <IntlProvider locale="vi" messages={messages}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <Suspense fallback={<LayoutSplashScreen />}>
              <BrowserRouter 
                basename={basename}
                future={{
                  // v7_startTransition defers route updates: URL changes while the previous
                  // page (e.g. /employees, /sale-orders) still renders and blocks the next fetch.
                  v7_relativeSplatPath: true
                }}
              >
                <AuthInit>
                  <Routes />
                </AuthInit>
              </BrowserRouter>
            </Suspense>
          </ThemeProvider>
        </IntlProvider>
      </Provider>
    </ErrorBoundary>
  )
}

export {App}
